import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState('');

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent('');
  };

  return (
    <>
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-8">
            <button
              onClick={() => openPopup('impressum')}
              className="hover:text-gray-300 transition-colors"
            >
              Impressum
            </button>
            <button
              onClick={() => openPopup('datenschutz')}
              className="hover:text-gray-300 transition-colors"
            >
              Datenschutz
            </button>
            <Link
              to="/widerruf"
              className="hover:text-gray-300 transition-colors"
            >
              Widerrufsbelehrung
            </Link>
            <button
              onClick={() => openPopup('agb')}
              className="hover:text-gray-300 transition-colors"
            >
              AGB
            </button>
          </div>
          <div className="text-center mt-6 text-sm text-gray-400">
            © 2025 Nadine Rau & Mike Trepte GbR. Alle Rechte vorbehalten.
          </div>
        </div>
      </footer>

      {/* Popup Modal */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold text-gray-900">
                  {popupContent === 'impressum' && 'Impressum'}
                  {popupContent === 'datenschutz' && 'Datenschutzerklärung'}
                  {popupContent === 'agb' && 'Allgemeine Geschäftsbedingungen'}
                </h2>
                <button
                  onClick={closePopup}
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                >
                  ×
                </button>
              </div>
              
              {popupContent === 'impressum' && (
                <div className="prose max-w-none text-gray-700 space-y-4">
                  <h3 className="text-lg font-semibold">Angaben gemäß § 5 TMG</h3>
                  <p>
                    Nadine Rau u. Mike Trepte GbR<br />
                    Bettenhäuserstr. 1<br />
                    34123 Kassel<br />
                    Deutschland
                  </p>
                  
                  <h3 className="text-lg font-semibold">Geschäftsführer</h3>
                  <p>Nadine Rau, Mike Trepte</p>
                  
                  <h3 className="text-lg font-semibold">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                  <p>Mike Trepte</p>
                  
                  <h3 className="text-lg font-semibold">Kontakt</h3>
                  <p>
                    Telefon: 0561 / 43027276<br />
                    E-Mail: <a href="mailto:mike.trepte@managershop.com" className="text-blue-600 hover:underline">mike.trepte@managershop.com</a><br />
                    Standort: Kassel, Deutschland
                  </p>
                  
                  <h3 className="text-lg font-semibold">Umsatzsteuer-ID</h3>
                  <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE338605405</p>
                  
                  <h3 className="text-lg font-semibold">Redaktionell verantwortlich</h3>
                  <p>
                    Mike Trepte<br />
                    Bettenhäuserstr. 1<br />
                    34123 Kassel
                  </p>
                  
                  <h3 className="text-lg font-semibold">Haftung für Inhalte</h3>
                  <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                  
                  <h3 className="text-lg font-semibold">Haftung für Links</h3>
                  <p>
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                  
                  <h3 className="text-lg font-semibold">Urheberrecht</h3>
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              )}

              {popupContent === 'datenschutz' && (
                <div className="prose max-w-none text-gray-700 space-y-4">
                  <h3 className="text-lg font-semibold">Datenschutzerklärung</h3>
                  <h4 className="text-base font-semibold mt-4">Datenschutz auf einen Blick</h4>
                  <p>
                    Diese Hinweise geben einen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder unser Kontaktformular nutzen. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
                  </p>
                  <p>Diese Website verwendet keine Cookies, keine Tracking-Dienste und keine Analyse-Tools.</p>
                  
                  <h4 className="text-base font-semibold mt-4">Verantwortliche Stelle</h4>
                  <p>
                    Nadine Rau u. Mike Trepte GbR<br />
                    Bettenhäuserstraße 1<br />
                    34123 Kassel<br />
                    E-Mail: mike.trepte@managershop.com<br />
                    Telefon: 0561 / 43027276
                  </p>
                  
                  <h4 className="text-base font-semibold mt-4">Bereitstellung der Website (Netlify / Strato)</h4>
                  <p>
                    Die Website wird über den Dienst Netlify bereitgestellt.<br /><br />
                    Netlify, Inc.<br />
                    2325 3rd Street, Suite 296<br />
                    San Francisco, CA 94107, USA
                  </p>
                  <p>
                    Die Domain ist bei Strato in Deutschland registriert; die Auslieferung der Inhalte erfolgt ausschließlich über Netlify.
                  </p>
                  <p>
                    Beim Aufruf der Website werden automatisch Server-Logfiles durch Netlify verarbeitet:<br /><br />
                    – IP-Adresse (gekürzt oder anonymisiert, je nach Hosting-Konfiguration)<br />
                    – Datum und Uhrzeit des Zugriffs<br />
                    – Browsertyp und -version<br />
                    – Betriebssystem<br />
                    – aufgerufene Seiten<br />
                    – Referrer-URL
                  </p>
                  <p>Diese Daten sind technisch erforderlich, um die Website funktionsfähig bereitzustellen.</p>
                  <p>
                    Aufgrund des Unternehmenssitzes von Netlify in den USA kann eine Datenübermittlung in ein Drittland nicht ausgeschlossen werden. Die Verarbeitung erfolgt auf Grundlage geeigneter Garantien, insbesondere der EU-Standardvertragsklauseln gemäß Art. 46 DSGVO.
                  </p>
                  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb).</p>
                  
                  <h4 className="text-base font-semibold mt-4">Datenerfassung über das Kontaktformular (GRETA / Questera)</h4>
                  <p>
                    Für das Kontaktformular nutzen wir den Dienst GRETA, ein Produkt des US-Unternehmens Questera.ai,<br />
                    149 Montgomery St, San Francisco, CA 94104, USA.
                  </p>
                  <p>
                    GRETA stellt das Formular und die technische Verarbeitung bereit, um die Daten per Webhook direkt an unser EU-basiertes System (Boost.space) zu übermitteln. GRETA speichert die Daten nicht dauerhaft. Aufgrund der technischen Einbindung kann eine Datenübermittlung in die USA nicht ausgeschlossen werden. Die Verarbeitung erfolgt unter Anwendung der EU-Standardvertragsklauseln gemäß Art. 46 DSGVO.
                  </p>
                  <p><strong>Erhobene Daten:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Vor- und Nachname</li>
                    <li>E-Mail-Adresse</li>
                    <li>Telefonnummer (optional)</li>
                    <li>Nachricht / Anliegen</li>
                    <li>Produktinteresse (falls angegeben)</li>
                    <li>Zustimmung zur Datenschutzerklärung</li>
                    <li>Zustimmung zu Werbung (falls erteilt)</li>
                  </ul>
                  <p><strong>Zwecke der Verarbeitung:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Bearbeitung der Anfrage</li>
                    <li>technische Übermittlung per Webhook</li>
                    <li>Kommunikation per E-Mail oder Telefon</li>
                    <li>Übertragung in weitere interne Systeme (siehe Abschnitt 4)</li>
                  </ul>
                  <p><strong>Rechtsgrundlagen:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
                    <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)</li>
                  </ul>
                  
                  <h4 className="text-base font-semibold mt-4">Weiterverarbeitung der Daten aus dem Kontaktformular</h4>
                  <p>Nach Eingang der Formularanfrage werden die Daten automatisiert an folgende Dienste übermittelt:</p>
                  
                  <p><strong>a) Boost.space (Tschechien, EU)</strong></p>
                  <p>
                    Wir nutzen Boost.space, betrieben von einem Unternehmen mit Sitz in Tschechien (Europäische Union), als zentrale Datenplattform („Single Source of Truth").
                  </p>
                  <p><strong>Verarbeitete Daten:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Name, E-Mail, Telefonnummer</li>
                    <li>Anfrageinhalt</li>
                    <li>Produktinteresse</li>
                    <li>erteilte Einwilligungen (Datenschutz, Werbung)</li>
                  </ul>
                  <p>Boost.space verarbeitet die Daten DSGVO-konform innerhalb der EU.</p>
                  <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. b und lit. f DSGVO</p>
                  
                  <p><strong>b) Make</strong></p>
                  <p>
                    Make wird zur Automatisierung der Datenübertragung zwischen GRETA, Boost.space und weiteren Systemen genutzt.
                  </p>
                  <p>
                    Make verarbeitet ausschließlich die Daten, die zur technischen Automatisierung erforderlich sind.
                  </p>
                  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Prozesssteuerung)</p>
                  
                  <p><strong>c) Acumbamail (Spanien, EU)</strong></p>
                  <p>
                    Für E-Mail-Kommunikation und Versand nutzen wir Acumbamail, einen Dienst mit Sitz in Spanien (Europäische Union).
                  </p>
                  <p><strong>Übermittelte Daten:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Name</li>
                    <li>E-Mail-Adresse</li>
                    <li>Telefonnummer (falls angegeben)</li>
                    <li>Einwilligungen (Datenschutz, Werbung)</li>
                  </ul>
                  <p>
                    Werbliche E-Mails erhalten Sie nur, wenn Sie dem ausdrücklich zugestimmt haben. Ohne Werbeeinwilligung erfolgt ausschließlich die notwendige Kommunikation im Rahmen Ihrer Anfrage oder Buchung.
                  </p>
                  <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. a und lit. b DSGVO</p>
                  
                  <p><strong>d) Nextcloud (Deutschland / EU)</strong></p>
                  <p>
                    Wir nutzen Nextcloud zur internen Dokumentenverwaltung, Terminorganisation und Datenspeicherung.
                    Nextcloud wird durch uns auf Servern in Deutschland bzw. innerhalb der Europäischen Union betrieben.
                  </p>
                  <p><strong>Verarbeitete Daten:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Kontakt- und Stammdaten</li>
                    <li>interne Notizen</li>
                    <li>Terminunterlagen</li>
                    <li>Dokumente zu Anfragen oder gebuchten Leistungen</li>
                  </ul>
                  <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. b und lit. f DSGVO</p>
                  
                  <h4 className="text-base font-semibold mt-4">Zahlungsabwicklung über Stripe</h4>
                  <p>Für die Bezahlung unserer Online-Seminare verwenden wir Stripe.</p>
                  <p>
                    Stripe Payments Europe, Ltd.<br />
                    The One Building<br />
                    Lower Grand Canal Street<br />
                    Dublin 2, Irland
                  </p>
                  <p>Stripe verarbeitet:</p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Name</li>
                    <li>E-Mail</li>
                    <li>Rechnungsinformationen</li>
                    <li>Zahlungsinformationen</li>
                    <li>IP-Adresse</li>
                    <li>verwendetes Zahlungsmittel</li>
                  </ul>
                  <p>
                    Stripe arbeitet DSGVO-konform und nutzt Verschlüsselungs- und Schutzmechanismen sowie EU-Standardvertragsklauseln. Es kann dabei auch zu Datenübermittlungen an Konzernunternehmen außerhalb der EU kommen; diese sind ebenfalls durch geeignete Garantien (u. a. Standardvertragsklauseln) abgesichert.
                  </p>
                  <p><strong>Rechtsgrundlagen:</strong></p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
                    <li>Art. 6 Abs. 1 lit. f DSGVO (sichere Zahlungsabwicklung)</li>
                  </ul>
                  <p>Weitere Informationen: <a href="https://stripe.com/de/privacy" className="text-blue-600 hover:underline">https://stripe.com/de/privacy</a></p>
                  
                  <h4 className="text-base font-semibold mt-4">Speicherdauer</h4>
                  <p>
                    Personenbezogene Daten werden gelöscht, sobald der Zweck der Verarbeitung entfällt.
                    Eine längere Speicherung erfolgt nur, wenn gesetzliche Aufbewahrungspflichten (z. B. handels- oder steuerrechtliche Vorschriften) bestehen.
                  </p>
                  
                  <h4 className="text-base font-semibold mt-4">Ihre Rechte</h4>
                  <p>Sie haben jederzeit das Recht auf:</p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Auskunft über die bei uns gespeicherten personenbezogenen Daten</li>
                    <li>Berichtigung unrichtiger Daten</li>
                    <li>Löschung</li>
                    <li>Einschränkung der Verarbeitung</li>
                    <li>Widerspruch gegen die Verarbeitung</li>
                    <li>Datenübertragbarkeit</li>
                  </ul>
                  <p>Anfragen richten Sie an:<br />E-Mail: mike.trepte@managershop.com</p>
                  
                  <h4 className="text-base font-semibold mt-4">Widerruf von Einwilligungen</h4>
                  <p>
                    Sie können eine erteilte Einwilligung zur Datenverarbeitung jederzeit mit Wirkung für die Zukunft per E-Mail widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt hiervon unberührt.
                  </p>
                  
                  <h4 className="text-base font-semibold mt-4">Sicherheit der Datenübertragung</h4>
                  <p>Diese Website nutzt SSL-/TLS-Verschlüsselung zur sicheren Übertragung von Daten.</p>
                  
                  <p className="mt-8 text-sm text-gray-500">Stand: November 2025<br />Diese Datenschutzinformationen werden regelmäßig überprüft und bei Bedarf aktualisiert.</p>
                </div>
              )}

              {popupContent === 'agb' && (
                <div className="prose max-w-none text-gray-700 space-y-4">
                  <h3 className="text-lg font-semibold">Allgemeine Geschäftsbedingungen (AGB)</h3>
                  <h4 className="text-base font-semibold mt-4">der Nadine Rau u. Mike Trepte GbR</h4>
                  
                  <h4 className="text-base font-semibold mt-6">§ 1 Geltungsbereich</h4>
                  <p>Diese AGB gelten für alle Verträge über die Erbringung von Online-Seminaren, Live-Programmen, Präsenzseminaren und Coaching-Dienstleistungen zwischen der Nadine Rau u. Mike Trepte GbR und den Teilnehmern.</p>
                  <p>Das Widerrufsrecht gilt ausschließlich für Verbraucher im Sinne des § 13 BGB.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 2 Vertragsgegenstand</h4>
                  <p>(1) Wir erbringen Dienstleistungen in den Bereichen:</p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Beratung und Implementierung von Software und KI-Tools</li>
                    <li>Personaldiagnostik mit MapsTell, Innermetrix und 9Levels</li>
                    <li>Coaching, Persönlichkeitsentwicklung und Führungskräfteentwicklung</li>
                    <li>Online- und Live-Seminare sowie Präsenzveranstaltungen</li>
                    <li>Tätigkeit als INQA-Coach (Initiative Neue Qualität der Arbeit)</li>
                  </ul>
                  <p>(2) Die Inhalte und Abläufe ergeben sich aus der jeweiligen Produktbeschreibung.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 3 Vertragsabschluss</h4>
                  <p>(1) Bei Online-Buchungen über Stripe oder andere Buchungssysteme kommt der Vertrag mit Abschluss des elektronischen Zahlungsvorgangs zustande.</p>
                  <p>(2) Mit der Buchung bestätigen Sie, diese AGB zur Kenntnis genommen zu haben.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 4 Preise und Zahlung</h4>
                  <p>(1) Die Preise ergeben sich aus der jeweils gültigen Produktbeschreibung.</p>
                  <p>(2) Zahlungen sind vor Beginn der Leistung fällig.</p>
                  <p>(3) Preisänderungen wirken nur für zukünftige Buchungen.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 5 Teilnahmevoraussetzungen</h4>
                  <p>(1) Die Teilnahme an Online-Programmen erfordert ein geeignetes Endgerät und eine stabile Internetverbindung.</p>
                  <p>(2) Die Teilnehmer verpflichten sich zur aktiven Mitarbeit und zum vertraulichen Umgang mit allen Gruppeninhalten.</p>
                  <p>(3) Die Verantwortung für persönliche Entscheidungen und Handlungen liegt bei den Teilnehmern selbst.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 6 Haftung</h4>
                  <p>(1) Unsere Haftung ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.</p>
                  <p>(2) Die Haftungsbeschränkung gilt nicht bei Verletzung von Leben, Körper oder Gesundheit.</p>
                  <p>(3) Unsere Leistungen ersetzen keine medizinische oder psychotherapeutische Behandlung.</p>
                  <p>(4) Bei der Implementierung von Software und KI-Tools übernehmen wir keine Haftung für die Funktionsfähigkeit der fremden Software oder die Korrektheit der KI-Ergebnisse. Wir unterstützen lediglich bei der Auswahl, Implementierung und Anwendung.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 7 Stornierung (freiwilliges Rücktrittsrecht)</h4>
                  <p>Diese Regelung betrifft ausschließlich Stornierungen, nicht den gesetzlichen Widerruf.</p>
                  <p>(1) Stornierungen sind schriftlich mitzuteilen.</p>
                  <p>(2) Für Online-Programme:<br />
                    – bis 14 Tage vor Beginn: vollständige Erstattung<br />
                    – ab 13 Tagen vor Beginn: keine Erstattung
                  </p>
                  <p>(3) Für Präsenzseminare (sofern angeboten):<br />
                    – bis 30 Tage vor Beginn: vollständige Erstattung<br />
                    – 29–14 Tage: 50 % Erstattung<br />
                    – 13–0 Tage: keine Erstattung<br />
                    – Ersatzteilnehmer können kostenfrei gestellt werden.
                  </p>
                  <p>(4) Für Beratungsleistungen und Diagnostik-Tools:<br />
                    – bis 7 Tage vor Termin: vollständige Erstattung<br />
                    – ab 6 Tagen vor Termin: keine Erstattung<br />
                    – Bei Nichterscheinen ohne Absage wird der volle Betrag fällig.
                  </p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 8 Vertraulichkeit</h4>
                  <p>Wir behandeln alle Informationen vertraulich. Dies gilt auch über das Vertragsende hinaus. Besonders gilt dies für im Rahmen der Personaldiagnostik erhobene persönliche Daten und Ergebnisse.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 9 Urheberrechte</h4>
                  <p>Alle bereitgestellten Materialien, insbesondere Diagnostik-Instrumente und Schulungsmaterialien, sind urheberrechtlich geschützt und dürfen nicht ohne unsere Zustimmung vervielfältigt werden.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 10 Anwendbares Recht und Gerichtsstand</h4>
                  <p>(1) Es gilt deutsches Recht.</p>
                  <p>(2) Für Unternehmer ist der Gerichtsstand Kassel.</p>
                  <p>(3) Für Verbraucher gilt der gesetzliche Gerichtsstand.</p>
                  
                  <h4 className="text-base font-semibold mt-6">§ 11 Salvatorische Klausel</h4>
                  <p>Die Unwirksamkeit einzelner Bestimmungen berührt die Wirksamkeit der übrigen Regelungen nicht.</p>
                  
                  <p className="mt-8 text-sm text-gray-500">Stand: November 2025</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;